import React from "react";
import { styled } from "styled-components";
import { BaseField } from "../types";
import { Textarea } from "../../Textarea";
import { FieldGroup, Label, HelperText } from "../shared";
import { useTheme } from "../../../theme";

const FormTextarea = styled(Textarea)(({ theme }) => ({
  width: "100%",
  borderRight: `1px solid rgba(115,115,118,0.3)`,
  borderRadius: theme.radii[1],
  minHeight: "80px",
  height: "auto",
}));

interface TextareaFieldProps {
  field: BaseField & { type: "textarea" };
  value: string;
  onChange: (value: string) => void;
}

export const TextareaField: React.FC<TextareaFieldProps> = ({
  field,
  value,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <FieldGroup>
      <Label htmlFor={field.id}>
        {field.label}
        {field.required && (
          <span style={{ color: theme.colors.warn }} aria-label="required">
            {" "}
            *
          </span>
        )}
      </Label>
      {field.helpText && (
        <HelperText id={`${field.id}-help`}>{field.helpText}</HelperText>
      )}
      <FormTextarea
        id={field.id}
        value={value}
        placeholder={field.placeholder}
        onValueChange={onChange}
        aria-required={field.required}
        aria-describedby={field.helpText ? `${field.id}-help` : undefined}
      />
    </FieldGroup>
  );
};
